const E = {
  2: 'Your Jobs & Samples search will list results in two tabs; Jobs which lists all Jobs found and Samples which lists all Samples of all Jobs found.',
};

const F = {
  2: 'Votre recherche Jobs & Samples listera les résultats dans deux onglets; Jobs qui répertorie tous les Jobs trouvés et échantillons qui répertorie tous les échantillons de tous les Jobs trouvés.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/tutorials/searchResultsJobs.js